import React from 'react';
import { useObserver, useLocalStore } from 'mobx-react-lite';
import styled from 'styled-components/macro';
import { useMst } from '../models/WithWineState';
import { ProductListProps } from '../types/ProductListProps';
import ProductCard from './ProductCard';
import { notEmptyFilter } from '../utils/notEmptyFilter';
import { useStoreFilterDefaults } from '../utils/hooks/useStoreFilterDefaults';
import { CartActionOption } from '../types/CartItemProps';

const UnstyledProductListItemsContainer: React.FC<ProductListProps> = (
  props,
) => {
  const productListId =
    props?.productlist_id || (props?.productlist && props.productlist.id);

  const stateTree = useMst();

  useStoreFilterDefaults(props.defaultfilter, props.sort);

  const state = useLocalStore(() => ({
    get productList() {
      if (productListId) {
        return stateTree.data.productLists.get(productListId);
      }

      return null;
    },
    get products() {
      if (
        productListId &&
        props.filterable &&
        props.filterable.toLowerCase &&
        props.filterable.toLowerCase() === 'true'
      ) {
        return stateTree.widgets.store.getFilteredProductListItems(
          productListId,
        );
      }

      return this.productList?.productListItems
        .map((item) => item.product)
        .filter(notEmptyFilter);
    },
  }));

  return useObserver(() => (
    <div
      className={'ww-widget ww-product-list ' + props.className}
      data-product-list-id={productListId}
    >
      {state.productList &&
        state.productList.isAvailable &&
        state.products &&
        state.products.length > 0 && (
          <div className="list">
            {state.products.map(
              (product) =>
                product && (
                  <ProductCard
                    variationsort={props.variationsort}
                    key={'pl_' + productListId + '_p_' + product.id}
                    toasteroptions={props.toasteroptions ?? {}}
                    cartaction={props.cartaction ?? CartActionOption.ShowCart}
                    data={product}
                    priceFormat={props.pricing}
                    hideBuyButton={state.productList?.showBuyButtons === false}
                    enablevariations={props.enablevariations}
                    trybutton={props.trybutton}
                    likebutton={props.likebutton}
                    buybutton={props.buybutton}
                  />
                ),
            )}
          </div>
        )}
    </div>
  ));
};

const ProductListItemsContainer = styled(UnstyledProductListItemsContainer)`
  color: var(--gray-5);
  width: 100%;

  .list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: center;
  }

  .no-results {
    padding: 5em;
    text-align: center;
    color: var(--gray-3);
  }
`;

export default ProductListItemsContainer;
